import KAMPYLE_CONSTANT from "./KAMPYLE_CONSTANT";
import KAMPYLE_DATA from "./KAMPYLE_DATA";
import KAMPYLE_EVENT_DISPATCHER from "./KAMPYLE_EVENT_DISPATCHER";
import KAMPYLE_FUNC from "./KAMPYLE_FUNC";
import KAMPYLE_UTILS from "./KAMPYLE_UTILS";
import MDIGITAL_LOCALIZATION from "./MDIGITAL_LOCALIZATION";
import CUSTOM_PARAMETERS from "./CUSTOM_PARAMETERS";
import MDIGITAL_ON_PREM from "./MDIGITAL_ON_PREM";
import MDIGITAL_LOGGER from "./MDIGITAL_LOGGER";
import COOLADATA_CODE from "./COOLADATA_CODE";
import KAMPYLE_COOLADATA from './KAMPYLE_COOLADATA'
import COOLADATA_UPGRADED_CODE from "./COOLADATA_UPGRADED_CODE";


  var COOLADATA_CONFIGURATION = {
    COOLADATA_APP_KEY: {
      PROD: 'qceuv8449dzg58ptt1bhda9g8ue19c7s',
      QA: 'lf5shxz66ckwmizs7kowapgs2rkoejcl'
    }
  };

  var rateLimitCounterMap = {};

  function shouldAppendCPValue(cp) {
    return !!KAMPYLE_CONSTANT.IBM_CPS_TO_SEND[cp.unique_name];
  }

  function formatCPValuesToSend(accumulator, current) {
    accumulator = accumulator || {};
    current = current || {};
    if (current.unique_name) {
      accumulator[current.unique_name] = CUSTOM_PARAMETERS.getCustomParamValueByUniqueName(current.unique_name);
    }
    return accumulator;
  }

  function enrichWithCPValues(data) {
    var cpValues = CUSTOM_PARAMETERS.getAllCustomParams()
      .filter(KAMPYLE_COOLADATA.shouldAppendCPValue)
      .reduce(KAMPYLE_COOLADATA.formatCPValuesToSend, {})
    return Object.assign({}, data, cpValues);
  }

  var COMMON_FIELDS;
  var allCooladataEvents = {};
  var nonDependentEvents = {
	neb_pageView: {
	  eventId: 'nebula_page_view',
	  disableProvision: KAMPYLE_CONSTANT.PROVISIONS.DISABLE_COOLADATA_NEW_PAGE_EVENTS
	},
	neb_inviteAccepted: {
	  eventId: 'nebula_invite_accepted',
	},
	neb_inviteDeclined: {
	  eventId: 'nebula_invite_declined',
	},
	neb_showInvitation: {
	  eventId: 'nebula_invitation_show',
	  memoryDataKey: 'invitationTriggeringData',
	  ...({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) && {formatDataFunc: appendDecibelData}
	},
	neb_feedbackSubmitted: {
	  eventId: 'nebula_form_submitted',
	  ...({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) && {formatDataFunc: appendDecibelData}
	},
	neb_formShown: {
	  eventId: 'nebula_form_show',
	  ...({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) && {formatDataFunc: appendDecibelData}
	},
	neb_buttonClicked: {
	  eventId: 'nebula_button_clicked',
	},
	neb_sdkShowForm: {
	  eventId: 'nebula_code_trigger_form',
	},
	neb_routeToForm: {
	  eventId: 'nebula_route_to_form',
	},
	neb_formClosed: {
	  eventId: 'nebula_form_closed',
	},
	neb_popupBlocked: {
	  eventId: 'nebula_popup_blocked',
	},
	neb_skipInvitation: {
	  eventId: 'nebula_invitation_skipped',
	},
	neb_formPageShown: {
	  eventId: 'nebula_form_page_displayed',
	},
	neb_captureInit: {
	  eventId: 'nebula_capture_init',
	},
	neb_captureImageClicked: {
	  eventId: 'nebula_capture_image_clicked',
	},
	MDigital_Capture_Cancelled: {
	  eventId: 'nebula_cancel_capture_clicked',
	},
	neb_cancel_capture_clicked: {
	  eventId: 'nebula_cancel_capture_clicked',
	},
	neb_sdkSurveyDisplayed: {
	  eventId: 'nebula_code_survey_displayed',
	},
	neb_afterHttpGetRequestOnError: {
	  eventId: 'nebula_after_http_get_request_on_error',
	  eventDataKey: 'httpRequestData',
	},
	neb_afterHttpGetRequestOnErrorStatusCode: {
	  eventId: 'nebula_after_http_get_request_on_error_status_code',
	  eventDataKey: 'httpRequestData',
	},
	neb_afterHttpGetRequestOnTimeout: {
	  eventId: 'nebula_after_http_get_request_on_timeout',
	  eventDataKey: 'httpRequestData',
	},
	neb_afterHttpGetRequest: {
	  eventId: 'nebula_after_http_get_request',
	  eventDataKey: 'httpRequestData',
	},
	neb_eventDispatcherError: {
	  eventId: 'nebula_eventDispatcherError',
	  eventDataKeys: ['errorMessage', 'errorStack', 'additionalInfo']
	},
	neb_feedbackUUIDisNull: {
	  eventId: 'nebula_feedbackUuidIsNull'
	},
	neb_submitFeedbackFailed: {
	  eventId: 'nebula_submitFeedbackFailed',
	  eventDataKeys: ['uuid', 'errorMessage', 'errorStack']
	},
	MDigital_warning: {
	  eventId: 'MDigital_warning',
	  eventDataKey: 'message'
	},
	MDigital_couldNotFetchData:{
	  eventId: 'MDigital_couldNotFetchData',
	  eventDataKey: 'errorData'
	},
	MDigital_couldNotLoadFormApplication:{
	  eventId: 'MDigital_couldNotLoadFormApplication',
	  eventDataKey: 'errorData'
	},
	MDigital_Invalid_Origin:{
	  eventId: 'MDigital_Invalid_Origin'
	},
	MDigital_noJsonModalShown: {
	  eventId: 'mdigital_noDataMessageDisplayed',
	  eventDataKey: 'additionalInfo'
	},
	screenCaptureRetake: {
	  eventId: KAMPYLE_CONSTANT.EVENTS.SCREEN_CAPTURE_RETAKE
	},
	screenCaptureDelete: {
	  eventId: KAMPYLE_CONSTANT.EVENTS.SCREEN_CAPTURE_DELETE
	},
  };
  
  var configurationDependentEvents = {
    neb_sessionStart: { 
      eventId: 'session_start', 
      provision: KAMPYLE_CONSTANT.PROVISIONS.ENABLE_COOLADATA_SESSION_EVENTS
    },
    neb_load_form_preload_proximity: {
      eventId: 'nebula_load_form_preload_proximity',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_load_form_form_reload: {
      eventId: 'nebula_load_form_form_reload',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_button_displayed: {
      eventId: 'nebula_button_displayed',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_invitation_loaded: {
      eventId: 'nebula_invitation_loaded',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_invitation_ready: {
      eventId: 'nebula_invitation_ready',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_form_loaded: {
      eventId: 'nebula_form_loaded',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    neb_formReady: {
      eventId: 'nebula_form_ready',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents,
    },
    MDigital_updatingSbtServer: {
      eventId: 'MDigital_updating_sbt_server',
      eventDataKey: 'dataObjForSbt',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_settingIdentifierValueOnMemory: {
      eventId: 'MDigital_setting_identifier_value_on_memory',
      eventDataKey: 'hasIdentifierValue',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_shouldNotSyncIdentifier: {
      eventId: 'MDigital_should_not_sync_identifier',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_beforeHttpPostRequest: {
      eventId: 'nebula_before_http_post_request',
      eventDataKey: 'httpRequestData',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnError: {
      eventId: 'nebula_after_http_post_request_on_error',
      eventDataKey: 'httpRequestData',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequest: {
      eventId: 'nebula_after_http_post_request',
      eventDataKey: 'httpRequestData',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnErrorStatusCode: {
      eventId: 'nebula_after_http_post_request_on_error_status_code',
      eventDataKey: 'httpRequestData',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_afterHttpPostRequestOnTimeout: {
      eventId: 'nebula_after_http_post_request_on_timeout',
      eventDataKey: 'httpRequestData',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithDeclinedDateInviteDeclined: {
      eventId: 'MDigital_update_targeting_with_declined_date_invite_declined',
      eventDataKey: 'declinedDate',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithSubmittedDate: {
      eventId: 'MDigital_update_targeting_with_submitted_date',
      eventDataKey: 'submittedDate',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_updateTargetingWithDeclinedDateFormClosed: {
      eventId: 'MDigital_update_targeting_with_declined_date_form_closed',
      eventDataKey: 'declinedDate',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_initUserIdentifier: {
      eventId: 'nebula_init_user_identifier',
      eventDataKey: 'hasIdentifierValue',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    neb_initUserIdentifierOnExtraData: {
      eventId: 'nebula_init_user_identifier_on_extra_data',
      eventDataKey: 'hasIdentifierValue',
      provision: KAMPYLE_CONSTANT.PROVISIONS.UBT_EXTRA_EVENTS,
    },
    MDigital_Form_Next_Page: {
      eventId: 'MDigital_Form_Next_Page',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_Form_Back_Page: {
      eventId: 'MDigital_Form_Back_Page',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_Form_Close_No_Submit: {
      eventId: 'MDigital_Form_Close_No_Submit',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_ThankYou_Displayed: {
      eventId: 'MDigital_ThankYou_Displayed',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_ThankYou_Close: {
      eventId: 'MDigital_ThankYou_Close',
      provision: KAMPYLE_CONSTANT.PROVISIONS.cooladataNewEvents
    },
    MDigital_pageTargetingPhaseEnded: {
      eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_PAGE_TARGETING_PHASE_ENDED,
      provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
      formatDataFunc: formatPageTargetingData,
      rateLimit: 1,
    },
    MDigital_behavioralTargetingPhaseEnded: {
      eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_BEHAVIORAL_TARGETING_PHASE_ENDED,
      provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
      formatDataFunc: formatBehavioralTargetingData,
      rateLimit: 1,
    },
    MDigital_quarantinedSurveyPhaseEnded: {
      eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_QUARANTINED_SURVEY_PHASE_ENDED,
      provision: KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING,
      formatDataFunc: formatQuarantineTargetingData,
      rateLimit: 1,
    },
    MDigital_DynamicOnsiteInitializedSuccessfully: {
      eventId: KAMPYLE_CONSTANT.EVENTS.MDIGITAL_DYNAMIC_ONSITE_INITIALIZED_SUCCESSFULLY,
      provision: KAMPYLE_CONSTANT.PROVISIONS.DYNAMIC_ONSITE_EVENTS,
    },
    MDigital_createSession:{
      eventId:KAMPYLE_CONSTANT.EVENTS.CREATE_SESSION,
      provision:KAMPYLE_CONSTANT.PROVISIONS.CREATE_SESSION,
      eventDataKey:'additionalData'
    },
    mdigital_customEventsDebugMessage: {
      eventId: KAMPYLE_CONSTANT.EVENTS.CUSTOM_EVENTS_DEBUG_MESSAGE,
      eventDataKeys:['customEventId', 'customEventData'],
      provision: KAMPYLE_CONSTANT.PROVISIONS.ENABLE_EVENTS_FOR_CE_DEBUG
    },
    MDigital_CHTML_Logs:{
      eventId:KAMPYLE_CONSTANT.EVENTS.MDIGITAL_CHTML_LOGS,
      provision:KAMPYLE_CONSTANT.PROVISIONS.CHTML_LOGS,
      eventDataKeys:['source_function','additional_data','error_logs']
    },
  };
  Object.assign(allCooladataEvents, nonDependentEvents);

  function appendDecibelData(payload) {
    var formData = KAMPYLE_DATA.getFormData(payload.formId);
    var decibelBehavioural = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelBehavioural');
    var decibelScore = KAMPYLE_UTILS.getNestedPropertyValue(formData, 'onSiteData.decibelScore');

    if (decibelBehavioural) {
      KAMPYLE_UTILS.setNestedPropertyValue(payload, 'decibelBehavioural', decibelBehavioural.eventName);
    }

    if (decibelScore) {
      var decibelData = KAMPYLE_DATA.getMemoryData(KAMPYLE_CONSTANT.MEMORY_DATA_FIELDS.DECIBEL_DATA);
      KAMPYLE_UTILS.setNestedPropertyValue(payload, 'decibelScore', {
        eventName: decibelScore.eventName,
        score: decibelData[decibelScore.eventName]
      });
    }
    return payload;
  }

  function initRateLimiting(specificEvents) {
	var events = specificEvents || allCooladataEvents;
    Object.keys(events).forEach(function (ev) {
      var eventObj = events[ev];
      if (isEventDefinedAsRateLimited(eventObj)) {
        rateLimitCounterMap[eventObj.eventId] = 0;
      }
    });
  }

  function getDataToSend(dataFormatted) {
    var feedbackUUID = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.BACKEND_GENERATED_UUID) ? dataFormatted.feedbackUUID : dataFormatted.feedbackCorrelationUUID;

    const isTargetingEventsReporting = KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.TARGETING_EVENTS_REPORTING);

    var dataToSend = {
      enviroment: dataFormatted.enviroment,
      accountId: dataFormatted.accountId,
      url: dataFormatted.pageURL,
      websiteId: dataFormatted.websiteId,
      feedback_uuid: feedbackUUID,
      formId: dataFormatted.formId || null,
      formTriggerType: KAMPYLE_DATA.getFormTriggerType(dataFormatted.formId),
      kampyle_data: dataFormatted.kampyle_data || null,
      cookie_size: dataFormatted.cookie_size || null,
      kampyle_version: dataFormatted.kampyle_version || '',
      onsite_version: window.MDIGITAL.version || '0.0.0.0',
      history_length: window.history.length,
      event_local_timestamp: KAMPYLE_UTILS.getCurrentTimestamp(),
      position: dataFormatted.position || null,
      isUserIdentified: !!KAMPYLE_DATA.getMemoryData('identifierValue'),
      feedback_correlation_uuid: KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.BACKEND_GENERATED_UUID) ? dataFormatted.feedbackCorrelationUUID : null,
    };

    if(isTargetingEventsReporting) {
      dataToSend = {
        ...dataToSend,
        mdigital_targetingData: JSON.stringify(dataFormatted.targetingData),
        mdigital_event_uuid: KAMPYLE_UTILS.kampyleCreateUUID()
      }
    }

    //TODO - add dynamic data more systematically
    if (dataFormatted.eventId === 'nebula_form_page_shown') {
      dataToSend.pageNumber = dataFormatted.pageNumber;
    }

    if (dataFormatted.eventId === 'nebula_route_to_form') {
      dataToSend.destinationForm = dataFormatted.formId;
    }

    if({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isDecibelEnabled) {
      if (dataFormatted.decibelBehavioural) {
        Object.assign(dataToSend, {
          decibelBehavioural: dataFormatted.decibelBehavioural
        });
      }
      if (dataFormatted.decibelScore) {
        Object.assign(dataToSend, {
          decibelScore: dataFormatted.decibelScore
        });
      }
    }
    
    if (dataFormatted.formId) {
      dataToSend.Web_form_lang = MDIGITAL_LOCALIZATION.getFormLanguage(dataFormatted.formId) || null;
    }

    if({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isOnPremEnabled) {
     dataToSend.packageVersion = MDIGITAL_ON_PREM.getPackageVersion();
    }


    if(KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.IBM_CP_INCLUSION)) {
      dataToSend = enrichWithCPValues(dataToSend);
    }

    addEventDataKeys(dataFormatted, dataToSend)

    return dataToSend;
  }

  function addEventDataKeys(dataFormatted, dataToSend) {
    var cooladataEvent = allCooladataEvents[dataFormatted.eventName];
    var eventDataKeys = cooladataEvent ? cooladataEvent.eventDataKeys : null;
    if (eventDataKeys) {
      for (var i = 0; i < eventDataKeys.length; i++) {
        dataToSend[eventDataKeys[i]] = dataFormatted[eventDataKeys[i]] || null;
      }
    }
  }

  function kampyleSendCoolaData(dataFormatted) {
    if (!dataFormatted || !window.cooladata) { return false; }
    var dataToSend = getDataToSend(dataFormatted);
    makeCooladataCall(dataFormatted.eventId, dataToSend);
    return true;
  }

  function formatData(eventName, oData) {
    if (!eventName || !oData) { return null; }

    var result = Object.assign({}, result, oData);

    //fill with defaults
    for (var prop in COMMON_FIELDS) {
      result[prop] = COMMON_FIELDS[prop];
    }

    //Fill with event specific variables
    for (var eventProp in allCooladataEvents[eventName]) {
      result[eventProp] = allCooladataEvents[eventName][eventProp];
    }

    var kampyleData = appendDataByEventName(eventName, KAMPYLE_UTILS.getAllKampyleData(), result);

    result.kampyle_data = kampyleData;
    result.cookie_size = KAMPYLE_UTILS.getByteSize(document.cookie);
    result.kampyle_version = window.MDIGITAL.version || '0.0.0.0';
    result.pageURL = location.href;
    result.eventName = eventName;
    return result;
  }

  var triggerCooladataEvent = function (eventName, oData) {
    var eventObj = allCooladataEvents[eventName];
    if (!(eventObj && isEventProvisioned(eventObj)) || isRateLimitExceeded(eventObj)) {
      return false;
    }

    var shouldFormatEventData = eventObj.formatDataFunc && typeof eventObj.formatDataFunc === 'function';
    if (shouldFormatEventData) {
      oData = eventObj.formatDataFunc.call(this, oData);
    }

    var oDataFormatted = formatData(eventName, oData);

    KAMPYLE_COOLADATA.kampyleSendCoolaData(oDataFormatted);
  }

  function isEventProvisioned(eventObj) {
    var isDisabled = eventObj.disableProvision && KAMPYLE_FUNC.checkProvision(eventObj.disableProvision);
    return !isDisabled && (!eventObj.provision || !!KAMPYLE_FUNC.checkProvision(eventObj.provision)); // Support backwards compatibility
  }

  function isEventDefinedAsRateLimited(eventObj) {
    return typeof eventObj.rateLimit === 'number' && eventObj.rateLimit > 0;
  }

  function getEventCallsCounter(eventId) {
    var counter = rateLimitCounterMap[eventId];
    return typeof counter === 'number' ? counter : null;
  }

  function isRateLimitExceeded(eventObj) {
    var counter = getEventCallsCounter(eventObj.eventId);
    return KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.COOLADATA_EVNETS_LIMIT) && typeof counter === 'number' && counter >= eventObj.rateLimit;
  }

  function increaseEventCallsCounter(eventId) {
    if (getEventCallsCounter(eventId) === null) {
      return null;
    }
    return ++(rateLimitCounterMap[eventId]);
  }

  function triggerCooladataEventDispatcherError(eventData) {
    if (!eventData || !window.cooladata) { return false; }
    var dataFormatted = formatData('neb_eventDispatcherError', eventData);
    var dataToSend = getDataToSend(dataFormatted);
    makeCooladataCall(dataFormatted.eventId, dataToSend);
    return dataToSend;
  }

  function makeCooladataCall(eventId, dataToSend) {
    try {
      getCooladataInstance().trackEvent(eventId, dataToSend);
      getEventCallsCounter(eventId) !== null && increaseEventCallsCounter(eventId);
    } catch (e) {
      console.warn(e);
    }
  }

  function getCooladataApiHost() {
    var cooladataApiHost = KAMPYLE_CONSTANT.PLACEHOLDERS.COOLADATA_API_HOST;
    if (cooladataApiHost.endsWith('/')) {
      //cooladata needs the url without the ending '/'
      cooladataApiHost = cooladataApiHost.substr(0, cooladataApiHost.length - 1);
    }
    return cooladataApiHost;
  }

  function getCooladataInstance() {
    return window.cooladata[KAMPYLE_CONSTANT.COOLADATA_INSTANCE_NAME]
  }

  function init() {
    try {
      COMMON_FIELDS = {
        userid: KAMPYLE_UTILS.kampyleGetUserId(),
      };

      var config = {
        cookie_expiration: KAMPYLE_DATA.getCookieExpiration(),
        app_key: KAMPYLE_UTILS.isDebugMode() ? COOLADATA_CONFIGURATION.COOLADATA_APP_KEY.QA : COOLADATA_CONFIGURATION.COOLADATA_APP_KEY.PROD,
        track_pageload: false, //send the page_load event every time a user views the page
        img_src_get_request: true,//send an image (1x1 pixel) as GET request for XHR requests
        api_host: getCooladataApiHost(), //set the api host,
      };

      try {
        if({"isOnPremEnabled":false,"isCooladataEnabled":false,"isCooladataUpgradeEnabled":false,"isCooladataOldEnabled":false,"isDigitalAnalyticsEnabled":false,"isCustomEventsEnabled":false,"isScreenCaptureEnabled":false,"isModalNewDialogEnabled":true,"isPropertyMessageEnabled":true,"isWCAGEnabled":false,"isAdobeAEnabled":false,"isGAEnabled":false,"isDecibelEnabled":false,"isThermoFisherTeaLeafEnabled":false}.isCooladataUpgradeEnabled) {
            COOLADATA_UPGRADED_CODE.init();
        } else {
          COOLADATA_CODE.init();
        }
        window.cooladata.init(config, null, KAMPYLE_CONSTANT.COOLADATA_INSTANCE_NAME);

        if (KAMPYLE_FUNC.checkProvision(KAMPYLE_CONSTANT.PROVISIONS.COOLADATA_EVNETS_LIMIT)) {
          initRateLimiting(nonDependentEvents);
          KAMPYLE_EVENT_DISPATCHER.subscribeOnce(KAMPYLE_CONSTANT.EVENTS.MDIGITAL_SDK_PAGE_VIEW, initRateLimiting);
        }
      } catch (e) {
        console.warn(e);
      }
      KAMPYLE_UTILS.initEventSubscriptions(nonDependentEvents, triggerCooladataEvent);
      //document.addEventListener('securitypolicyviolation', sendSecurityPolicyViolationEvent);
      return true;
    } catch (e) {
      console.warn(e);
    }

  }

  function registerConfigurationDependentEvents() {
    Object.assign(allCooladataEvents, configurationDependentEvents);
    initRateLimiting(configurationDependentEvents);
    KAMPYLE_UTILS.initEventSubscriptions(configurationDependentEvents, triggerCooladataEvent);
  }

  function sendSecurityPolicyViolationEvent(e) {
    if(!e.blockedURI || !(e.blockedURI.indexOf('kampyle')>-1 || e.blockedURI.indexOf('medallia')>-1))
        return;
    var csp = {
      additionalInfo: {},
      errorMessage: e.type + ': ' + e.blockedURI,
      errorStack: 'violatedDirective: ' + e.violatedDirective
    };
    KAMPYLE_EVENT_DISPATCHER.appendDefaultEventParams(csp.additionalInfo)
    triggerCooladataEventDispatcherError(csp);
  }

  function getUserId() {
    var userId;
    try {
      userId = KAMPYLE_DATA.getData('cd_user_id') || getCooladataInstance().config.user_id || null;
    } catch (e) {
      console.warn(e);
    }


    return userId;
  }

  function appendDataByEventName(eventName, dataObj, eventJsonData) {
    eventJsonData = eventJsonData || {};
    var memoryDataKey = allCooladataEvents[eventName].memoryDataKey;
    var memoryData = KAMPYLE_DATA.getMemoryData(memoryDataKey);
    if (memoryData) {
      dataObj[memoryDataKey] = memoryData;
    }
    var eventDataKey = allCooladataEvents[eventName].eventDataKey;
    var eventData = eventJsonData[eventDataKey];
    if (eventData) {
      dataObj[eventDataKey] = eventData;
    }
    return dataObj;
  }

  function getFinalConditionResult(accumulator, current) {
    return accumulator && current.isPassed;
  }

  function getFormTargetingData(form, targetingPhase) {
    form = form || {};
    var formState = KAMPYLE_DATA.getFormState(form.formId);
    if (!formState || !formState.targeting) {

      MDIGITAL_LOGGER.error("Cooladata - getFormTargetingData: failed to build " + targetingPhase + " phase data for form id: " + form.id);

      return false;
    }

    var conditions = formState.targeting[targetingPhase];
    var dataToSend = {
      formId: form.formId,
      formType: form.formType,
      evaluationResult: conditions === null ? false : (conditions || []).reduce(getFinalConditionResult, true),
      conditions: conditions
    };

    return dataToSend;
  }

  function formatPageTargetingData() {
    var dataToSend = [];
    var allForms = KAMPYLE_DATA.getAllForms() || [];
    allForms.forEach(function (form) {
      dataToSend.push(getFormTargetingData(form, KAMPYLE_CONSTANT.TARGETING_PHASES.PAGE_TARGETING));
    });
    return { targetingData: dataToSend };
  }

  function formatBehavioralTargetingData(formData) {
    return { targetingData: getFormTargetingData(formData, KAMPYLE_CONSTANT.TARGETING_PHASES.BEHAVIORAL_TARGETING) };
  }

  function formatQuarantineTargetingData(formData) {
    var form = getFormTargetingData(formData, KAMPYLE_CONSTANT.TARGETING_PHASES.QUARANTINE_TARGETING) || {};
    form.hasUserIdentifier = !!KAMPYLE_DATA.getMemoryData('identifierValue');
    form.userIdentifierValue = KAMPYLE_DATA.getMemoryData('identifierValue');
    return { targetingData: form };
  }

  export default {
    //for testing
    getDataToSend: getDataToSend,
    kampyleSendCoolaData: kampyleSendCoolaData,
    formatData: formatData,
    appendDataByEventName: appendDataByEventName,
    addEventDataKeys: addEventDataKeys,
    rateLimitCounterMap: rateLimitCounterMap,
    isEventProvisioned: isEventProvisioned,
    isEventDefinedAsRateLimited: isEventDefinedAsRateLimited,
    getEventCallsCounter: getEventCallsCounter,
    isRateLimitExceeded: isRateLimitExceeded,
    increaseEventCallsCounter: increaseEventCallsCounter,
    initRateLimiting: initRateLimiting,
    init: init,
    registerConfigurationDependentEvents: registerConfigurationDependentEvents,
    triggerCooladataEvent: triggerCooladataEvent,
    getCooladataInstance: getCooladataInstance,
    getUserId: getUserId,
    triggerCooladataEventDispatcherError: triggerCooladataEventDispatcherError,
    shouldAppendCPValue: shouldAppendCPValue,
    formatCPValuesToSend: formatCPValuesToSend,
    enrichWithCPValues: enrichWithCPValues,
    formatPageTargetingData: formatPageTargetingData,
    formatBehavioralTargetingData: formatBehavioralTargetingData,
    formatQuarantineTargetingData: formatQuarantineTargetingData,
    getFormTargetingData: getFormTargetingData
  };
